import React from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const GoToCapTable = ({ capTableURL }: { capTableURL: string }) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => {
        navigate(capTableURL);
      }}
      startIcon={<ArrowBackIcon />}>
      Add Security
    </Button>
  );
};

export default GoToCapTable;
